import styled from 'styled-components'

import ActionButton from '../ActionButton'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3rem;
  border: 1px solid ${({ theme }) => theme.colors.royalBlue};
  overflow: hidden;
  width: 100%;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colors.neonBlue};
  align-items: center;
  justify-content: center;
`

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.H4};
  color: ${({ theme }) => theme.colors.pureWhite};
  margin: 2.5rem 0;
`

export const Button = styled(ActionButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1.3rem;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.2rem 2rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
`
